import React from 'react';
import { useSelector } from 'react-redux';
import GroupBatchList from './GroupBatchList';
import { Loading } from '../../../Other/Loading';

const InstructorBatchSchedules = () => {
  const user = useSelector((state) => state.users.user);
  const instructorId = user?.userId || user?.id;

  if (!user) {
    return <Loading />;
  }

  return (
    <div className="mx-auto p-6 bg-white">
      <div className="dashboard-container-new mb-6">
        <p className="text-slate-800 font-extrabold text-lg">My Batch Schedules</p>
      </div>
      <GroupBatchList instructorId={instructorId} />
    </div>
  );
};

export default InstructorBatchSchedules;
